module.exports = __webpack_public_path__ + "img/d.fa926e52.png";